import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '../loading/loading';
import './button-next-step.scss';

export interface ButtonSaveProps {
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

export const ButtonSave = (props: ButtonSaveProps): JSX.Element => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (!(props.isLoading || props.disabled)) {
            props.onClick();
        }
    };

    return (
        <div className="button__style--fourth">
            <Button variant="contained" onClick={handleClick} disabled={props.disabled}>
                {props.isLoading ? (
                    <div
                        style={{
                            position: 'relative',
                            width: '185px',
                            top: '15px'
                        }}
                    >
                        <Loading />
                    </div>
                ) : (
                    <>
                        {t('accept-invite.buttons.next-step').toUpperCase()}
                        <InputAdornment position="end">
                            <div className="button--arrow" />
                        </InputAdornment>{' '}
                    </>
                )}
            </Button>
        </div>
    );
};

export default ButtonSave;
